// extracted by mini-css-extract-plugin
export default {"mt20":"index_mt20_ugSiT","hardAd":"index_hardAd_U1ntG"};